module.exports = __webpack_public_path__ + "main/assets/public/email/rrr-logo.65227b0a5439e687.png";